import styled from 'styled-components'
import { COLOR } from '../../design/color/color.constants'
import { SPACING } from '../../design/spacing/spacing.constants'
import { FullWidthCardWrapper } from './full-width-card-wrapper.component'
import { RowCardWrapper } from './row-card-wrapper.component'

const Card = styled.section`
  flex: 1;
  padding: ${SPACING.M};
  margin-bottom: ${SPACING.M};
  border: 1px solid ${COLOR.GREY_LIGHT};

  & + & {
    margin-left: ${SPACING.M};

    ${FullWidthCardWrapper} & {
      margin-left: 0;
    }
  }

  &:last-of-type,
  ${RowCardWrapper} & {
    margin-bottom: 0;
  }

  border-radius: ${props => (props.borderRounded ? '10px' : '0')};
`

Card.displayName = 'Card'

export { Card, FullWidthCardWrapper }
